import { Button, Drawer } from 'antd'
import React from 'react'

const DrawerComponent = ({
	form,
	visible,
	onOpen,
	buttonTitle,
	buttonType,
	onClose,
	drawerTitle,
	drawerWidth,
	isHidden
}) => (
	<div>
		<Button type={buttonType || 'primary'} onClick={onOpen} className={`${isHidden ? 'hidden' : ''}`}>
			{buttonTitle}
		</Button>
		<Drawer
			title={drawerTitle || buttonTitle}
			width={drawerWidth || 700}
			onClose={onClose}
			open={visible}
			style={{ body: { paddingBottom: 80 } }}
			footer={
				<div
					style={{
						textAlign: 'right'
					}}
				/>
			}
			destroyOnClose
		>
			{form}
		</Drawer>
	</div>
)

export default DrawerComponent
